export default __webpack_public_path__ + "static/media/poisson.3a6501d6.webp";